




























import washSymbols from '@/components/wash-icons/symbols';

interface IWashingStruct {
  [category: string]: string[];
}

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}) as IWashingStruct,
    },
  },
  data: () => ({
    washSymbols,
    titles: {
      BLEACH: 'Bleaching',
      DRY_CLEAN_SOLVENT: 'Dry Cleaning',
      DRYING: 'Drying',
      IRONING_TEMP: 'Ironing Temperatures',
      TUMBLE_DRY: 'Tumble Drying',
      WASH: 'Machine / Hand Washing',
    },
  }),
  methods: {
    isSelected(category: string, code: string) {
      const categoryItems = this.value[category] || [];
      return categoryItems.includes(code);
    },
    update(category: string, code: string) {
      let values = (this.value as IWashingStruct)[category] || [];
      const doesValueExistIndex = values.indexOf(code);
      const optionKey = 'OPTION_';

      if (doesValueExistIndex > -1) {
        // remove from values if it already exists (i.e. toggle)
        values = [
          ...values.slice(0, doesValueExistIndex),
          ...values.slice(doesValueExistIndex + 1),
        ];
      } else if (code.includes(optionKey)) {
        // add to list of values if value contains option
        values = values.concat(code);
      } else {
        values = values
          .filter((option: string) => option.includes(optionKey))
          .concat(code);
      }

      this.$emit('input', {
        ...this.value,
        [category]: values,
      });
    },
  },
} as IView;
